import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReassignParams } from "../../../domain/entities/supervisor-delivery";
import { type SupervisorDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reassign = createAsyncThunk<
  void,
  ReassignParams,
  { dispatch: SupervisorDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REASSIGN, async (params, { extra }) => {
  await extra.supervisorDeliveryRepo.reassign(params);
});
